<div class="p-2 text-center userActivate">
  <img  [src]="imageURL | async" alt="Active Image">
</div>
<div class="text-center">
  <h1 class="my-2">Hi, {{name}}!</h1>
  <span *ngIf="!defaultWelMesg">{{welcomeContent | async}} </span>
  <span *ngIf="defaultWelMesg"></span>
</div>
<div *ngIf="showAC" class="container-fluid col-md-6 mt-2 m-auto">
  <form [formGroup]="activationForm" *ngIf="getCondtions.length > 0 && showAC" autocomplete="new-form" class="row p-2">
    <div class="col-md-12 mb-2 text-center p-0">
      <div *ngIf="showActErr" class="error-message">
        <em class="fa fa-exclamation-triangle error-message__icon"></em>
        <div class="error-message__text">{{ activationErr }}</div>
      </div>
    </div>
    <div class="activationCodeContainer">
      <div class="note">
        <span><em class="fa fa-info-circle"></em><br>
          <p innerHtml="{{ getActivationMessage() }}"></p>
        </span>
      </div>
      <div class="col-md-12 mb-2 text-center" *ngIf="showEmail">
        <label class="formLabel" for="emailActivationCode"><em class="fa fa-fw fa-envelope font-size-20px"></em>
          {{'email_activation_code'|translate}} <span class="text-danger">*</span></label>

        <div class="otp-input-container mt-2">
          <div *ngFor="let i of [0, 1, 2, 3, 4, 5]; let index = index" class="otp-input-box">

            <input #otpInput type="tel" minlength="1" maxlength="1" (input)="onInputChange($event,'emailotp' + index)"
              [id]="'emailotpInput' + index" [formControlName]="'emailotp' + index" (keyup)="onOtpInput(index,'Email')"
              (keydown)="onBackspaceKeyDown($event, index,'Email')">
          </div>
        </div>
        <div *ngIf="emailActivationCodeReq" class="d-flex justify-content-center text-danger">
          <small>{{'email_Activation_Code_required'|translate}}</small>
        </div>
        <div *ngIf="!emailActivationCodeReq&&emailActivationCodeValidReq"
          class="d-flex justify-content-center text-danger">
          <small>{{'Valid_email_Activation_Code_required'|translate}}</small>
        </div>
      </div>
      <div class="col-md-12 mb-2 text-center" *ngIf="showPhone">
        <label class="formLabel" for="phoneActivationCode"><em class="fa fa-fw fa-phone font-size-20px"></em>
          {{'phone_activation_code'|translate}} <span class="text-danger">*</span></label>
        <div class="otp-input-container mt-2">
          <div *ngFor="let i of [0, 1, 2, 3, 4, 5]; let index = index" class="otp-input-box">
            <input #otpInput type="tel" minlength="1" (input)="onInputChange($event,'phoneotp' + index)" maxlength="1"
              [id]="'phoneotpInput' + index" [formControlName]="'phoneotp' + index" (keyup)="onOtpInput(index,'Phone')"
              (keydown)="onBackspaceKeyDown($event, index,'Phone')">
          </div>
        </div>
        <div *ngIf="phoneActivationCodeReq" class="d-flex justify-content-center text-danger">
          <small>{{'phone_Activation_Code_required'|translate}}</small>
        </div>
        <div *ngIf="!phoneActivationCodeReq&&phoneActivationCodeValidReq"
          class="d-flex justify-content-center text-danger">
          <small>{{'Valid_phone_Activation_Code_required'|translate}}</small>
        </div>
      </div>
      <div class="col-md-12 mb-2 text-center" *ngIf="showWhats">
        <label class="formLabel" for="whatsappActivationCode"><em class="fa fa-fw fa-whatsapp font-size-20px"></em>
          {{'whatsApp_activation_code'|translate}}<span class="text-danger">*</span></label>
        <div class="otp-input-container mt-2">
          <div *ngFor="let i of [0, 1, 2, 3, 4, 5]; let index = index" class="otp-input-box">
            <input #otpInput type="tel" minlength="1" maxlength="1" [id]="'watsotpInput' + index"
              (input)="onInputChange($event,'watsotp' + index)" [formControlName]="'watsotp' + index"
              (keyup)="onOtpInput(index,'WhatsApp')" (keydown)="onBackspaceKeyDown($event, index,'WhatsApp')">
          </div>
        </div>
        <div *ngIf="whatsActivationCodeReq" class="d-flex justify-content-center text-danger">
          <small>{{'WhatsApp_Activation_Code_required'|translate}}</small>
        </div>
        <div *ngIf="!whatsActivationCodeReq&&whatsActivationCodeValidReq"
          class="d-flex justify-content-center text-danger">
          <small>{{'Valid_whatsapp_Activation_Code_required'|translate}}</small>
        </div>
      </div>
    </div>

    <div class="col-md-12 my-2 text-center">
      <button type="submit" class="btn btn-success" *ngIf="(showEmail || showPhone || showWhats)"
        (click)="onSubmit()"><em class="fa fa-arrow-right fa-fw"></em> {{'next'|translate}}</button>
    </div>
  </form>
</div>


<!-- OTP VALIDATION -->

<div *ngIf="OTPscreen" class="container-fluid col-md-10 mt-2 m-auto">

  <form [formGroup]="activationForm" *ngIf="getCondtions.length > 0 && OTPscreen" autocomplete="new-form"
    class="row p-2">
    <div class="col-md-12 mb-2 text-center p-0">
      <div *ngIf="showOTPErr" class="error-message">
        <em class="fa fa-exclamation-triangle error-message__icon"></em>
        <div class="error-message__text">{{ passwordErr }}</div>
      </div>
    </div>
    <div class="activationCodeContainer">
      <div class="note">
        <span><em class="fa fa-info-circle"></em><br>

          <p innerHtml="{{ getOtpMessage() }}"></p>
        </span>
      </div>
      <div class="col-md-12 mb-2 text-center" *ngIf="showEmail">
        <label class="formLabel" for="emailActivationCode"><em class="fa fa-fw fa-envelope font-size-20px"></em>
          {{'email_OTP'|translate}} <span class="text-danger">*</span></label>

        <div class="otp-input-container mt-2">
          <div *ngFor="let i of [0, 1, 2, 3, 4, 5]; let index = index" class="otp-input-box">
            <input #otpInput type="tel" minlength="1" maxlength="1" (keypress)="numberOnly($event)"
              (input)="onInputChange($event,'emailotp' + index)" [id]="'emailotpInput' + index"
              [formControlName]="'emailotp' + index" (keyup)="onOtpInput(index,'Email')"
              (keydown)="onBackspaceKeyDown($event, index,'Email')">
          </div>
        </div>
        <div *ngIf="otpReq" class="d-flex justify-content-center text-danger">
          <small>{{'OTP_is_required'|translate}}</small>
        </div>
        <div *ngIf="!otpReq&&otpValidReq" class="d-flex justify-content-center text-danger">
          <small>{{'valid_OTP_is_required'|translate}}</small>
        </div>
      </div>
      <div>
        <p class="text-center my-2" *ngIf="showResendButton==true">
          {{ 'If you do not receive OTP' | translate }} <a href="javascript:void(0)" (click)="resendOTP()">Resend
            OTP</a>
        </p>
        <div class="load" *ngIf="showResendButton==false">
          <div class="progress-time mx-4" [style.--progress-value]="timeRemaining_percent">
            <progress style="visibility:hidden;height:0;width:0;"></progress>
            <span class="progress-value">{{remainingTime}}</span>
          </div>
        </div>

      </div>
    </div>
    <div class="col-md-12 my-2 text-center">
      <button type="submit" class="btn btn-success" *ngIf="(showEmail)" (click)="otpVerify()"><em
          class="fa fa-arrow-right fa-fw"></em> {{'next'|translate}}</button>
    </div>
  </form>

</div>



<!-- Password  -->

<div *ngIf="isPassword" class="container-fluid  mt-2 m-auto">
  <div class="text-center my-4">
    <h6>{{'account_already_verified' | translate}}</h6>
  </div>

  <div class="col-md-6 m-auto">
    <form [formGroup]="passwordForm" autocomplete="off" class="row mt-1">
      <div class="col-md-12 text-center p-0">
        <div *ngIf="showPassErr" class="error-message">
          <em class="fa fa-exclamation-triangle error-message__icon"></em>
          <div class="error-message__text">{{ passwordErr }}</div>
        </div>
      </div>
      <div class="activationCodeContainer">
        <div class="col-md-12 mb-2">
          <label class="formLabel font-weight-bold" for="newpassword">{{'New_PassWord'|translate}}<span
              class="text-danger">*</span></label>
          <input type="password" formControlName="newpassword"
            [ngClass]="{'is-invalid': passwordForm.get('newpassword')?.invalid && (passwordForm.get('newpassword')?.dirty || passwordForm.get('newpassword')?.touched),
              'is-valid': passwordForm.get('newpassword')?.valid && (passwordForm.get('newpassword')?.dirty || passwordForm.get('newpassword')?.touched)}"
            name="newpassword" id="newpassword" class="form-control" autocomplete="new-password">

          <div class="invalid-feedback"
            *ngIf="passwordForm.get('newpassword')?.invalid && (passwordForm.get('newpassword')?.dirty || passwordForm.get('newpassword')?.touched)">
            <div *ngIf="passwordForm.get('newpassword')?.errors?.['required']">{{'new_password_required'|translate}}
            </div>
            <div *ngIf="passwordForm.get('newpassword')?.errors?.['pattern']">{{'password_error_message'|translate}}
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-2">
          <label class="formLabel font-weight-bold" for="newpassword">{{'Confirm_New_PassWord'|translate}} <span
              class="text-danger">*</span></label>
          <input type="password" formControlName="connewpassword"
            [ngClass]="{'is-invalid': passwordForm.get('connewpassword')?.invalid && (passwordForm.get('connewpassword')?.dirty || passwordForm.get('connewpassword')?.touched),
              'is-valid': passwordForm.get('connewpassword')?.valid && (passwordForm.get('connewpassword')?.dirty || passwordForm.get('connewpassword')?.touched)}"
            name="connewpassword" id="connewpassword" class="form-control" autocomplete="off">
          <div class="invalid-feedback"
            *ngIf="passwordForm.get('connewpassword')?.invalid && (passwordForm.get('connewpassword')?.dirty || passwordForm.get('connewpassword')?.touched)">
            <div *ngIf="passwordForm.get('connewpassword')?.errors?.['required']">{{'new_password_required'|translate}}
            </div>
            <div *ngIf="passwordForm.get('connewpassword')?.errors?.['mustMatch']">{{'pass_match'|translate}}</div>
            <div *ngIf="passwordForm.get('connewpassword')?.errors?.['pattern']">{{'password_error_message'|translate}}
            </div>
          </div>
        </div>
      </div>


      <div class="col-12 text-center mt-2">
        <button type="submit" class="btn btn-success me-1" (click)="submit()">
          <em class="fa fa-check fa-fw"></em> {{'next'|translate}}
        </button>
      </div>

    </form>

  </div>

</div>


<div *ngIf="MFALogin">
  <app-mfa-login [uniqueCode]="uniqueCode" (MFALoginSuccess)="MFALoginSuccess($event)"></app-mfa-login>
</div>

<div *ngIf="MFATransaction">
  <app-mfa-tranaction [uniqueCode]="uniqueCode"
    (MFATransactionSuccess)="MFATransactionSuccess($event)"></app-mfa-tranaction>
</div>


<!-- Transaction pin set -->


<div *ngIf="transactionPin" class="container-fluid  mt-2 m-auto">
  <div class="text-center my-4">
    <h6>{{'set_transaction_pin' | translate}}</h6>
  </div>

  <div class="col-md-6 m-auto">
    <form [formGroup]="passwordForm" autocomplete="off" class="row mt-1">
      <div class="col-md-12 text-center p-0">
        <div *ngIf="showTransPassErr" class="error-message">
          <em class="fa fa-exclamation-triangle error-message__icon"></em>
          <div class="error-message__text">{{ passwordErr }}</div>
        </div>
      </div>
      <div class="activationCodeContainer">
        <div class="col-md-12 mb-2">
          <label class="formLabel font-weight-bold" for="newpassword">{{'Transaction_Pin'|translate}}<span
              class="text-danger">*</span></label>
          <input type="password" formControlName="newpassword"
            [ngClass]="{'is-invalid': passwordForm.get('newpassword')?.invalid && (passwordForm.get('newpassword')?.dirty || passwordForm.get('newpassword')?.touched),
              'is-valid': passwordForm.get('newpassword')?.valid && (passwordForm.get('newpassword')?.dirty || passwordForm.get('newpassword')?.touched)}"
            name="newpassword" id="newpassword" class="form-control" autocomplete="new-password">

          <div class="invalid-feedback"
            *ngIf="passwordForm.get('newpassword')?.invalid && (passwordForm.get('newpassword')?.dirty || passwordForm.get('newpassword')?.touched)">
            <div *ngIf="passwordForm.get('newpassword')?.errors?.['required']">{{'transaction_required'|translate}}
            </div>
            <div *ngIf="passwordForm.get('newpassword')?.errors?.['pattern']">
              {{'transaction_pin_error_message'|translate}}
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-2">
          <label class="formLabel font-weight-bold" for="newpassword">{{'confirm_transaction_pin'|translate}}<span
              class="text-danger">*</span></label>
          <input type="password" formControlName="connewpassword"
            [ngClass]="{'is-invalid': passwordForm.get('connewpassword')?.invalid && (passwordForm.get('connewpassword')?.dirty || passwordForm.get('connewpassword')?.touched),
              'is-valid': passwordForm.get('connewpassword')?.valid && (passwordForm.get('connewpassword')?.dirty || passwordForm.get('connewpassword')?.touched)}"
            name="connewpassword" id="connewpassword" class="form-control" autocomplete="off">
          <div class="invalid-feedback"
            *ngIf="passwordForm.get('connewpassword')?.invalid && (passwordForm.get('connewpassword')?.dirty || passwordForm.get('connewpassword')?.touched)">
            <div *ngIf="passwordForm.get('connewpassword')?.errors?.['required']">
              {{'confirm_transaction_required'|translate}}
            </div>
            <div *ngIf="passwordForm.get('connewpassword')?.errors?.['mustMatch']">{{'Transaction_Pin_match'|translate}}
            </div>
            <div *ngIf="passwordForm.get('connewpassword')?.errors?.['pattern']">
              {{'transaction_pin_error_message'|translate}}
            </div>
          </div>
        </div>
      </div>


      <div class="col-12 text-center mt-2">
        <button type="submit" class="btn btn-success me-1" (click)="TransactionSubmit()">
          <em class="fa fa-check fa-fw"></em> {{'next'|translate}}
        </button>
      </div>

    </form>

  </div>

</div>








<div *ngIf="isActivated" class="container-fluid col-md-6 mt-2 m-auto">
  <div class="pageHeader">
    <h2 class="title mb-0 centered-text">{{'activation_code'|translate}}</h2>
  </div>
  <form [formGroup]="isActivationForm" autocomplete="new-form" class="row p-2">
    <div class="col-md-12 mb-2 text-center p-0">
      <div *ngIf="showIsActErr" class="error-message">
        <em class="fa fa-exclamation-triangle error-message__icon"></em>
        <div class="error-message__text">{{ isActivationErr }}</div>
      </div>
    </div>
    <div class="activationCodeContainer">
      <div class="col-md-12 mb-2">
        <label class="formLabel font-weight-bold" for="email">{{'email'|translate}}<span
            class="text-danger">*</span></label>
        <input formControlName="email" id="email" type="email" class="form-control"
          [ngClass]="{'is-invalid': isActivationForm.get('email')?.invalid && (isActivationForm.get('email')?.dirty || isActivationForm.get('email')?.touched),
            'is-valid': isActivationForm.get('email')?.valid && (isActivationForm.get('email')?.dirty || isActivationForm.get('email')?.touched)}" />
        <div class="invalid-feedback"
          *ngIf="isActivationForm.get('email')?.invalid && (isActivationForm.get('email')?.dirty || isActivationForm.get('email')?.touched)">
          <div *ngIf="isActivationForm.get('email')?.errors?.['required']">{{'email_required'|translate}}</div>
        </div>
      </div>
      <div class="col-md-12 mb-2">
        <label class="formLabel font-weight-bold" for="phoneNumber">{{'Phone_Number'|translate}}<span
            class="text-danger">*</span></label>
        <div class="input-group">
          <div class="input-group-prepend">
            <select class="form-control" id="countryCode" formControlName="phoneCC"
              [ngClass]="{'is-invalid':isActivationForm.get('countryCode')?.touched &&  isActivationForm.get('countryCode')?.errors?.['required'] || 
              isActivationForm.get('countryCode')?.['invalid'] && isActivationForm.get('countryCode')?.errors?.['pattern']}">

              <option *ngFor="let code of phoneCodes" [value]="code.dial_code">
                <span> {{code.code}} ({{code.dial_code}})</span>
              </option>
            </select>
          </div>
          <input formControlName="phoneNumber" (keypress)="numberOnly($event)" id="phoneNumber" type="tel"
            class="form-control"
            [ngClass]="{'is-invalid': isActivationForm.get('phoneNumber')?.invalid && (isActivationForm.get('phoneNumber')?.dirty || isActivationForm.get('phoneNumber')?.touched),
            'is-valid': isActivationForm.get('phoneNumber')?.valid && (isActivationForm.get('phoneNumber')?.dirty || isActivationForm.get('phoneNumber')?.touched)}" />
          <div class="invalid-feedback"
            *ngIf="isActivationForm.get('phoneNumber')?.invalid && (isActivationForm.get('phoneNumber')?.dirty || isActivationForm.get('phoneNumber')?.touched)">
            <div *ngIf="isActivationForm.get('phoneNumber')?.errors?.['required']">{{'PHONE_NUMBER_REQUIRED'|translate}}
            </div>
            <div *ngIf="isActivationForm.get('phoneNumber')?.errors?.['pattern']">
              {{'ENTERINSURED_VALIDPHONENUMBER'|translate}}</div>
          </div>
        </div>

      </div>
    </div>
    <div class="col-md-12 my-2 text-center">
      <button type="submit" class="btn btn-success" *ngIf="(showEmail || showPhone || showWhats)"
        (click)="onIsActiveSubmit()" [disabled]="isActivationForm.invalid"><em class="fa fa-arrow-right fa-fw"></em>
        {{'next'|translate}}</button>
    </div>
  </form>
</div>







<div *ngIf="isfullyVerified" class="container-fluid mt-2">
  <div class="text-center my-4">
    <h6>{{ 'account_verified_login' | translate}}
    </h6>
  </div>
  <div class="col-md-12 my-2 text-center">
    <button type="button" class="btn btn-success" (click)="goToLogin()"><em
        class="fa fa-arrow-right fa-fw"></em>
      {{'Go_To_Login'|translate}}</button>
  </div>
</div>

<div *ngIf="idInvalid" class="container-fluid mt-2">
  <div class="text-center my-4">
    <h6>{{ 'invalid_activation_code' | translate}}
      <a href="mailto:{{supportMail}}" target="_blank" rel="noopener">{{supportMail}}</a>
    </h6>

  </div>
</div>